<template>
  <div class="popup">
    <div class="popup__title">
      <div class="title">Map</div>
    </div>
    <div style="height: 400px; width: 100%;">
      <GmapMap :center="center" :options="options" style="width: 100%; height: 400px">
        <GmapMarker
            :position="marker"
            :clickable="true"
            :draggable="false"
            @click="center=marker"/>
      </GmapMap>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import {mapGetters} from 'vuex'

  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_API_MAPKEY,
      libraries: 'places', // This is required if you use the Autocomplete plugin
    },
  })

  export default {
    name: "ModalMap",
    data() {
      return {
        options: {
          zoom: 5,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false,
        },
        center: {lat: 0, lng: 0},
        marker: {lat: 0, lng: 0},
        position: null
      }
    },
    computed: {
      ...mapGetters([
        'getModalData',
      ]),
    },
    mounted() {
      this.center = {lat: this.getModalData.lat, lng: this.getModalData.lng}
      this.marker = {lat: this.getModalData.lat, lng: this.getModalData.lng}
    },
  }
</script>

<style scoped>
  .popup {
    padding: 50px 100px !important
  }
</style>